import { axiosClient } from '@nx-frontend/shared/api';
import { webnotesClientEnv } from '@nx-frontend/webnotes-client/shared';

export async function getEditorTemplates(): Promise<unknown | null> {
  try {
    const editorTemplatesUrl = `${webnotesClientEnv.editorServerUrl}/templates`;
    const response = await axiosClient.get<unknown>(editorTemplatesUrl);
    return response.data;
  } catch (err) {
    console.error('Error fetching editor templates:', err);
    return null;
  }
}
